// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-page {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    margin-top: 50px;
}

@media (min-width: 1000px) {
    .language-page {
        margin-top: 0;
        height: 100vh;
    }
}

.language-page > div {
    margin-bottom: 25px;
    column-gap: 0;
    row-gap: 0;
}

@media (min-width: 768px) {
    .language-page > div {
        margin-right: 25px;
    }

    .language-page > div:last-of-type {
        margin-right: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/language/LanguagePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;QACb,aAAa;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,UAAU;AACd;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".language-page {\n    display: flex;\n    flex-wrap: wrap;\n    align-content: center;\n    margin-top: 50px;\n}\n\n@media (min-width: 1000px) {\n    .language-page {\n        margin-top: 0;\n        height: 100vh;\n    }\n}\n\n.language-page > div {\n    margin-bottom: 25px;\n    column-gap: 0;\n    row-gap: 0;\n}\n\n@media (min-width: 768px) {\n    .language-page > div {\n        margin-right: 25px;\n    }\n\n    .language-page > div:last-of-type {\n        margin-right: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
